<template>
  <div
    v-if="bankAccount"
    class="mb-4 mt-6"
  >
    <div class="mb-2 border-b border-gray-dark pb-2">
      <span
        class="font-bold"
        v-text="'Account Holder Name: '"
      />
      <span v-text="bankAccount.account_holder_name" />
    </div>
    <div class="mb-2 border-b border-gray-dark pb-2">
      <span
        class="font-bold"
        v-text="'Bank Name: '"
      />
      <span v-text="bankAccount.bank_name" />
    </div>
    <div class="mb-2 border-b border-gray-dark pb-2">
      <span
        class="font-bold"
        v-text="'Account Number Last 4: '"
      />
      <span v-text="bankAccount.last4" />
    </div>
    <div class="mb-2 border-b border-gray-dark pb-2">
      <span
        class="font-bold"
        v-text="'Routing Number: '"
      />
      <span v-text="bankAccount.routing_number" />
    </div>
    <div class="mb-2 border-b border-gray-dark pb-2">
      <span
        class="font-bold"
        v-text="'Statement Descriptor: '"
      />
      <span v-text="statementDescriptor" />
    </div>
    <button
      class="btn btn--sm"
      type="button"
      @click="$emit('showForm')"
      v-text="'Update Bank Account'"
    />
  </div>
</template>

<script type="text/babel">
import { mapState } from 'vuex'

export default {
  name: 'BankAccountInfo',
  computed: {
    ...mapState({
      stripeAccount: state => state.payments.stripeAccount,
    }),
    bankAccount() {
      return this.stripeAccount.external_accounts.data[0]
    },
    statementDescriptor() {
      return this.stripeAccount.settings.payouts.statement_descriptor || ''
    },
  },
}
</script>